module.exports = __webpack_public_path__ + "img/lounge_spirits_group.10fab381.png";